import React, { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';

import axios from 'axios';
import { formatMoneda, formatoMonto, validaMonto, validaSoloNumero, seleccionarCampo } from '../../util/varios';
import { Mensaje, MensajeSiNo } from '../mensajes2';
import { Dimmer } from '../spinner';

import moment from 'moment';
import useTableFijo from '../useTableFijo';
 

export const ModalModificarFact = (props) => {

    let op = require('../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));
    const idusuario = JSON.parse(localStorage.getItem('idusuario'));
    const fechaSistema = JSON.parse(localStorage.getItem('fechasistema'));
    const anioefis = JSON.parse(localStorage.getItem('efiscalanio'));

    const [records, setRecords] = useState([]);
    const [itemSelect, setItemSelect] = useState(-1);

    const [activate, setActivate] = useState(false);
    const [deshabilitado, setDeshabilitado] = useState(false);
    const [habiBase, setHabiBase] = useState(true);
    const [habiAlicuo, setHabiAlicuo] = useState(true);
    const [habiRete, setHabiRete] = useState(true);
    const [habiFecha, setHabiFecha] = useState(true);
    const [visibleDat, setVisibleDat] = useState('visible');
    const [factor, setFactor] = useState(0.00);
    const [sustraendo, setSustraendo] = useState(0.00);
    const [operacion, setOperacion] = useState(0);
    const [mostrar4, setMostrar4] = useState(false);
    const [desde, setDesde] = useState(0);
    const [nomCampo, setNomCampo] = useState(0);
    const [valorUt, setValorUt] = useState(0.00);
    const [activo, setActivo] = useState(true);
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [sumaRete, setSumaRete] = useState(0.00);
    const [rete_porciento, setRete_Porciento] = useState(0.00);
    const [datos, setDatos] = useState();
    const btnCancela = useRef();
    const btnAcepta = useRef();
    const txtIdRetencion = useRef();
    const txtDescriret = useRef();
    const txtFechaRet = useRef();
    const txtBaseImpo = useRef();
    const txtMontoCompro = useRef();
    const txtNumFactura = useRef([]);
    const txtNumControl = useRef([]);
    const txtFecha = useRef([]);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } });

    const txtUbi = useRef();

    const txtTipo = useRef();
    const txtMotivo = useRef();
    const txtIdordenpago = useRef();

    const headCells = [
        { id: '1', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'N° Factura', textAlign: 'center' },
        { id: '2', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'N° Control', textAlign: 'center' },
        { id: '3', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Fecha Fact', textAlign: 'center' },

    ]

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTableFijo(records, headCells, filterFn, 220);


    const cancelar = () => {
        blanquear();
        props.onHideCancela();
    }
    const blanquear = () => {
        setActivate(false);
        setActivo(true);
        setHabiAlicuo(true);
        setHabiBase(true);
        setHabiFecha(true);
        setVisibleDat('visible');
    };
    const cerrarModal = () => {
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
        if (desde === 1){
            setTimeout(() => {
                if (nomCampo === 'numfactura') {
                    txtNumFactura.current[itemSelect].focus();
                } else if (nomCampo === 'numcontrol') {
                    txtNumControl.current[itemSelect].focus();
                } else if (nomCampo === 'fecfactura') {
                    txtFecha.current[itemSelect].focus();
                }
            }, 100);
        }
        /*props.onDatos(datos);
        props.onHideCancela();
        blanquear();*/
    }
    const handleInputChange = (index) => (e) => {
        /*if (e.target.id === 'numfactura' || e.target.id === 'numcontrol') {
          validaSoloNumero(e);
        }*/ 

        if (e.which === 13) {
            if (e.target.id === 'numfactura') {
                modificarFactura(records[index].idfacturaxorden, 'numfactura', txtNumFactura.current[index].value, index)
            } else if (e.target.id === 'numcontrol') {
                modificarFactura(records[index].idfacturaxorden, 'numcontrol', txtNumControl.current[index].value, index)
            } else if (e.target.id === 'fecfactura') {
                modificarFactura(records[index].idfacturaxorden, 'fecfactura', txtFecha.current[index].value, index)
            }
        } else if (e.which === 46) {
            return false;
        } else if (e.which >= 48 && e.which <= 57) {
            return true;
        } else if (e.which === 8 || e.which === 0 || e.which === 44) {
            return true;
        } else return false;//alert(e.which);
    };

    const modificarFactura = (id, nomcampo, valor, index) => {
        var sigue = true;
        if (nomcampo === 'numfactura'){ 
            for (let i = 0; i < records.length; i++) {
                if (i != index){
                    if(records[i].numfactura === txtNumFactura.current[index].value){
                        setDesde(1);
                        setNomCampo('numfactura');
                        setItemSelect(index);
                        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'LA FACTURA YA EXISTE', icono: 'informacion' });
                        //txtNumFactura.current[index].focus();
                        return;
                    }
                }
            }
            if (txtNumFactura.current[index].value === ``) {
                setDesde(1);
                setNomCampo('numfactura');
                setItemSelect(index);
                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El Número de Factura no debe estar vacio.', icono: 'informacion' });
                sigue = false;
                //txtNumFactura.current[index].focus();
            }
        } else if (nomcampo === 'numcontrol' && txtNumControl.current[index].value === ``) {
            setDesde(1);
            setNomCampo('numcontrol');
            setItemSelect(index);
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El Número de Control no debe estar vacio.', icono: 'exito' });
            sigue = false;
            //txtNumControl.current[index].focus();
        } else if (nomcampo === 'fecfactura'  && txtFecha.current[index].value === ``) {
            setDesde(1);
            setNomCampo('fecfactura');
            setItemSelect(index);
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'La Fecha es invalida', icono: 'exito' });
            sigue = false;
            //txtFecha.current[index].focus();
        } else if (new Date(txtFecha.current[index].value).getFullYear() !== anioefis) {
            setDesde(1);
            setNomCampo('fecfactura');
            setItemSelect(index);
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El año no debe ser diferente al año del Ejercicio Fiscal actual', icono: 'informacion' });
            sigue = false;
            //txtFecha.current[index].focus();
        } 
        if (sigue){
            let body = {
                idfacturaxorden: id,
                nomcampo: nomcampo,
                valor: valor,
                idefiscal: idefiscal,
            };
            let endpoint = `${op.conexion}/api/administracion/modificarfacturaxorden`;
            setActivate(true);
            axios.post(endpoint, body, {
                headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        }
            }).then(function (response) {
                if (response.status == 200) {
                    if (nomcampo === 'numfactura') {
                        setDesde(1);
                        setNomCampo('numcontrol');
                        setItemSelect(index);
                        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El Número de Factura Fue Modificado', icono: 'exito' });
                        records[index].numfactura = valor;
                        //txtNumControl.current[index].focus();
                    } else if (nomcampo === 'numcontrol') {
                        //txtFecha.current[index].focus();
                        setDesde(1);
                        setNomCampo('fecfactura');
                        setItemSelect(index);
                        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El Número de Control Fue Modificado', icono: 'exito' });
                        records[index].numcontrol = valor;
                    } else if (nomcampo === 'fecfactura') {
                        //txtNumFactura.current[index + 1 === records.length ? index : index + 1].focus();
                        setDesde(1);
                        setNomCampo('numfactura');
                        setItemSelect(index + 1 === records.length ? index : index + 1);
                        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'La Fecha Fue Modificada', icono: 'exito' });
                        records[index].fecfactura = valor;
                    } 
                        
                }
                setActivate(false);
            }).catch(function (error) {
    
                setActivate(false);
                setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
    
            })
        }

    };

    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                setOperacion(props.operacion);
                setRecords(props.data);
                setTimeout(() => {
                    txtNumFactura.current[0].focus();
                }, 150);
                //console.log(props.data)
            }}>
            <Modal.Header className='header-azulGradiant'>
                <h3>
                    Modificar Facturas
                </h3>
                <a type='button' onClick={cancelar}>
                    salir<i className="far fa-window-close"></i>
                </a>
            </Modal.Header>
            <Modal.Body>
              <Dimmer active={activate} inverted>
       
      </Dimmer>
                <div className='col-12 m-0 p-0'>
                    <TblContainer container={{ height: 150, width: '100%', overflow: 'auto', padding: '2px' }}>
                    <TblHead />
                        <tbody>
                            {
                                records.map((item, index) => (
                                    <tr key={item + item.numfactura} className="table-bordered">
                                        <td style={{ fontSize: "10px", textAlign: "center", width: "60px" }}><input className='form-control text-right' ref={el => txtNumFactura.current[index] = el} defaultValue={item.numfactura} type="text" id="numfactura" name="name" onKeyUp={handleInputChange(index)} /></td>
                                        <td style={{ fontSize: "10px", textAlign: "center", width: '60px' }}><input className='form-control text-right' ref={el => txtNumControl.current[index] = el} defaultValue={item.numcontrol} type="text" id="numcontrol" name="name" onKeyUp={handleInputChange(index)} /></td>
                                        <td style={{ fontSize: "10px", textAlign: "center", width: "60px" }}><input className='form-control text-right' ref={el => txtFecha.current[index] = el} defaultValue={moment.utc(item.fecfactura).format('YYYY-MM-DD')} type="date" id="fecfactura" name="name" onKeyUp={handleInputChange(index)} /></td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </TblContainer>
                </div>
            </Modal.Body>
            <Modal.Footer className='footer-azulGradiant'>
                {/* <button type="button" ref={btnAcepta} onClick={onChangeValidar} disabled={activo} style={{ margin: '1px' }} className="fw-bold btn btn-success btn-sm rounded-pill"><i className="far fa-check-circle"></i> Aceptar</button>
                 */}
                <button type="button" 
                    ref={btnCancela} 
                    onClick={cancelar} 
                    className="btn btn-sm btnSecondary-azulGradiant rounded">
                    <i className="fas fa-window-close"></i> Salir
                </button>
            </Modal.Footer>
            <Mensaje mensaje={mensaje}
                onHide={cerrarModal} />
        </Modal>
    );
}